import React, {ReactNode} from 'react';

import {Box, Grid, Typography, Paper} from '@material-ui/core';

export const BuyerPage = () => (
    <Box p={0}>
        {/* === BUYER DETAILS === */}
        <Section title="BUYER DETAILS">
            <Grid container spacing={4}>
                <Field label="Full name" value="Jean-Baptiste Mbaye" />
                <Field label="Electronic Health Record" value="0236547891" />
            </Grid>
        </Section>

        {/* === BUYER CONTACT === */}
        <Section title="BUYER CONTACT">
            <Grid container spacing={4}>
                <Field label="Phone number" value="+236 752 14 990" />
                <Field label="Email" value="jean.mbaye@protonmail.com" />
                <Field label="Medical institution" value="Abuja Central Hospital" />
            </Grid>
        </Section>

        {/* === PRESCRIPTION DETAILS === */}
        <Section title="PRESCRIPTION DETAILS">
            <Grid container spacing={4}>
                <Field label="Prescription number" value="RX-2025-15872" />
                <Field label="Prescription date" value="06.10.2025" />
                <Field label="Medical institution" value="Bangui Central Hospital" />
                <Field
                    label="Reason for purchase"
                    value="Treatment of chronic respiratory condition"
                />
            </Grid>
        </Section>

        {/* === PRODUCT RESTRICTIONS === */}
        <Section title="PRODUCT RESTRICTIONS">
            <Grid container spacing={4}>
                <Field label="Restricted product" value="Yes" />
                <Field label="Requirement" value="Prescription needed" />
            </Grid>
        </Section>
    </Box>
);

/* ---- Components ---- */

function Section({title, children}: {title: string; children: ReactNode}) {
    return (
        <Box mb={2}>
            <Typography
                variant="subtitle2"
                style={{marginBottom: 8, fontWeight: 700, color: '#555'}}
            >
                {title}
            </Typography>

            <Paper
                elevation={0}
                style={{
                    padding: 8,
                    borderRadius: 8,
                    // border: '1px solid #eee',
                }}
            >
                {children}
            </Paper>
        </Box>
    );
}

function Field({label, value}: {label: string; value: string}) {
    return (
        <Grid item xs={12} md={4}>
            <Typography variant="body2" style={{color: '#939AA4', fontSize: 13, marginBottom: 2}}>
                {label}
            </Typography>
            <Box
                style={{
                    backgroundColor: '#E8E8FC',
                    padding: '3px 6px',
                    borderRadius: 6,
                    display: 'inline-block',
                    fontWeight: 400,
                    fontSize: 13,
                    color: '#333',
                    borderRight: '1px solid #eee',
                }}
            >
                {value}
            </Box>
        </Grid>
    );
}
